class SocialGallery extends HTMLElement {
    constructor() {
      super();
      this.splide_selector = `data-splide-container`;
      this.splide_container = this.querySelector(`[${this.splide_selector}]`);
      this.splide_list_selector = `data-splide-list`;
      this.splide_list = this.querySelector(`[${this.splide_list_selector}]`);
      this.album_name = this.dataset.album || "Home"
  
      if (window.Splide) {
        this.init();
      } else {
        document.getElementById('splide-script').addEventListener('load', this.init());
      }
  
      if (Shopify.designMode) {
        document.addEventListener('shopify:section:load', function (e) {
          const social_gallery = e.target.querySelector('social-gallery');
          if (social_gallery) social_gallery.init();
        });
  
        document.addEventListener('shopify:section:deselect', (e) => {
          const social_gallery = e.target.querySelector('social-gallery');
          if (social_gallery) social_gallery.init();
        });
      }
    }
  
    init() {
    const app_key = "WF739e2yEBxun5OXSydoxdwnxnSPBm4IlhBqlvHT"
    const url = `https://api.yotpo.com/v1/widget/${app_key}/albums/by_name?album_name=${this.album_name.replace(/(^\w{1})|(\s+\w{1})/g, letter => letter.toUpperCase())}`
    const that = this
    const options = {
        method: 'GET',
        headers: { Accept: 'application/json', 'Content-Type': 'application/json' }
    }

    fetch(url, options)
        .then(res => res.json())
        .then(json => {
            json.response.images.forEach( e => {
                const { medium_image_url } = e
                const slide = `<li class="splide__slide"><img src="${medium_image_url}"/></li>`
                that.splide_list.insertAdjacentHTML('beforeend', slide);
            })
        })
        .then(() =>{
            const splide = new Splide(that.splide_container);
            splide.on('pagination:mounted', function (data) {
                data.list.classList.add('splide__pagination--custom');
            });
            splide.mount();
        })
        .catch(err => console.error('error:' + err));
    }
  }
  
  if (!customElements.get('social-gallery')) customElements.define('social-gallery', SocialGallery);
  